import React, { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { PDFDownloadLink } from "@react-pdf/renderer";
import { getUrlParams, getGoqiiUserId } from "../apiService/timespam";
import { lifestyleApi } from "../apiService/api";
import MonthlyPdf from "../Components/MonthlyPdf";
import "./Theme.css";
import "./DownloadMonthlyPdf.css";

const DownloadMonthlyPdf = () => {
  const { t } = useTranslation();
  const { theme, lang } = getUrlParams();
  const goqiiUserId = getGoqiiUserId();
  const [logs, setLogs] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    document.documentElement.className = theme === "dark" ? "dark" : "";
    document.documentElement.dir = lang === "ar" ? "rtl" : "ltr";
  }, [theme, lang]);

  useEffect(() => {
    lifestyleApi.fetchMonthlyReport({ goqiiUserId })
      .then((res) => setLogs(res.data.data || {}))
      .catch(() => {})
      .finally(() => setLoading(false));
  }, []);

  if (loading) return <div className="pdf-loading">{t("common.loading")}</div>;

  return (
    <section className="pdf-page">
      <div className="pdf-container">
        <h1 className="pdf-title">{t("monthlyPdf.title")}</h1>
        <p className="pdf-subtitle">{t("monthlyPdf.subtitle")}</p>
        {logs && (
          <PDFDownloadLink
            document={<MonthlyPdf logs={logs} />}
            fileName="Monthly_Skin_Report.pdf"
            className="pdf-download-btn"
          >
            {({ loading: pdfLoading }) =>
              pdfLoading ? t("monthlyPdf.generating") : t("monthlyPdf.downloadBtn")
            }
          </PDFDownloadLink>
        )}
      </div>
    </section>
  );
};

export default DownloadMonthlyPdf;
